<template>
  <div class="case-ledger bg-white rounded-sm border overflow-hidden">
    <!-- Header -->
    <div class="px-4 py-3 d-flex align-center justify-space-between border-b bg-slate-50/50">
      <div class="d-flex align-center">
        <v-icon color="primary" class="mr-2">mdi-book-open-variant</v-icon>
        <span
          class="text-subtitle-2 font-weight-black grey--text text--darken-4 uppercase tracking-widest"
        >
          Loan Ledger & Repayment History
        </span>
        <v-chip
          v-if="selectedCase?.caseNo"
          small
          color="primary"
          label
          class="ml-4 font-weight-black uppercase"
        >
          {{ selectedCase?.caseNo }}
        </v-chip>
        <v-chip small color="grey darken-3" dark label class="ml-2 font-weight-black uppercase">
          Records: {{ filteredEntries.length }}
        </v-chip>
        <!-- <v-chip x-small color="primary" label class="ml-2 font-weight-black uppercase">
          Total: {{ formatCurrency(totalDebit) }}
        </v-chip> -->
      </div>
      <div class="d-flex align-center gap-4">
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          label="Search Ledger..."
          flat
          outlined
          dense
          hide-details
          class="search-field rounded-sm mr-4"
          background-color="white"
          style="max-width: 300px"
        ></v-text-field>
        <v-btn
          small
          color="primary"
          depressed
          @click="fetchLedgerData(1)"
          :loading="loading"
          class="rounded-sm font-weight-black normal-case h-8 px-4"
        >
          <v-icon left size="16">mdi-refresh</v-icon>
          Refresh Ledger
        </v-btn>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              color="primary"
              depressed
              v-bind="attrs"
              v-on="on"
              :disabled="loading || !filteredEntries.length"
              class="rounded-sm font-weight-black normal-case h-8 px-4"
            >
              <v-icon left size="16">mdi-download</v-icon>
              Download Ledger
              <v-icon right size="16">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="downloadLedgerPDFMake">
              <v-list-item-icon class="mr-2 my-1">
                <v-icon size="16" color="primary">mdi-download</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-xs font-weight-medium"
                  >Corporate Template</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="downloadLedgerPDF">
              <v-list-item-icon class="mr-2 my-1">
                <v-icon size="16" color="secondary">mdi-download</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-xs font-weight-medium"
                  >Standard Template</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>

    <!-- PDF Components (Hidden) -->
    <CaseLedgerPDF
      ref="ledgerPDF"
      :selectedCase="selectedCase"
      :ledgerEntries="filteredEntries"
      orgName="Zavron Finance Pvt Ltd"
      :branchName="computedBranchName"
    />
    <CaseLedgerPDFMake
      ref="ledgerPDFMake"
      :selectedCase="selectedCase"
      :ledgerEntries="filteredEntries"
      orgName="Zavron Finance Pvt Ltd"
      :branchName="computedBranchName"
    />

    <!-- Table Container - Stabilized vertical scroll -->
    <div class="overflow-y-auto overflow-x-auto h-[850px] max-h-[80vh] border-b">
      <table class="w-full border-collapse ledger-table py-0">
        <thead class="bg-slate-100 border-b-2 border-slate-200 sticky top-0 z-30 shadow-sm">
          <tr>
            <th
              class="px-2 py-3 text-left text-subheading-sm font-semibold grey--text text--darken-2 normal-case border-r"
            >
              Date
            </th>
            <th
              class="px-2 py-3 text-left text-subheading-sm font-semibold grey--text text--darken-2 normal-case border-r"
            >
              Post Date
            </th>
            <th
              class="px-2 py-3 text-left text-subheading-sm font-semibold grey--text text--darken-2 normal-case border-r"
            >
              Account Name
            </th>
            <th
              class="px-2 py-3 text-left text-subheading-sm font-semibold grey--text text--darken-2 normal-case border-r"
            >
              Voucher Type
            </th>
            <th
              class="px-2 py-3 text-left text-subheading-sm font-semibold grey--text text--darken-2 normal-case border-r"
            >
              Voucher No
            </th>
            <th
              class="px-2 py-3 text-left text-subheading-sm font-semibold grey--text text--darken-2 normal-case border-r"
            >
              Inst No
            </th>
            <th
              class="px-2 py-3 text-right text-subheading-sm font-semibold grey--text text--darken-2 normal-case border-r"
            >
              Debit
            </th>
            <th
              class="px-2 py-3 text-right text-subheading-sm font-semibold grey--text text--darken-2 normal-case border-r"
            >
              Credit
            </th>
            <th
              class="px-2 py-3 text-right text-subheading-sm font-semibold grey--text text--darken-2 normal-case border-r"
            >
              Balance
            </th>
            <th
              class="px-2 py-3 text-center text-subheading-sm font-semibold grey--text text--darken-2 normal-case border-r"
            >
              Cr/Dr
            </th>
            <th
              class="px-2 py-3 text-left text-subheading-sm font-semibold grey--text text--darken-2 normal-case border-r"
            >
              Comments
            </th>
            <!-- <th
              class="px-2 py-3 text-left text-[10px] font-weight-black grey--text text--darken-2 uppercase tracking-widest"
            >
              Post Type
            </th> -->
          </tr>
        </thead>
        <tbody>
          <!-- Loading State -->
          <tr v-if="loading" class="border-b">
            <td colspan="12" class="text-center py-16">
              <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
              <div class="mt-4 text-xs font-weight-black grey--text uppercase opacity-50">
                Syncing Ledger Data...
              </div>
            </td>
          </tr>

          <!-- Empty State -->
          <tr v-else-if="!filteredEntries.length" class="border-b">
            <td colspan="12" class="text-center py-16 bg-slate-50/20">
              <v-icon size="48" color="grey lighten-3">mdi-folder-open-outline</v-icon>
              <div class="mt-4 text-xs font-weight-black grey--text uppercase opacity-40">
                No entries recorded for this loan
              </div>
            </td>
          </tr>

          <!-- Data Rows -->
          <tr
            v-for="(entry, index) in filteredEntries"
            :key="index"
            class="border-b transition-all cursor-pointer"
            :class="[entry.isDeleted ? 'soft-deleted-row' : 'hover:bg-slate-50']"
          >
            <td
              class="px-2 py-1.5 text-[11px] font-weight-bold grey--text text--darken-3 border-r whitespace-nowrap"
            >
              {{ formatDate(entry.date) }}
            </td>
            <td class="px-2 py-1.5 text-[10px] grey--text border-r whitespace-nowrap leading-tight">
              {{ formatDateTime(entry.createdAt) }}
            </td>
            <td
              class="px-2 py-1.5 text-[11px] font-weight-black primary--text border-r whitespace-nowrap uppercase tracking-tighter"
            >
              {{ entry.particulars }}
            </td>
            <td
              class="px-2 py-1.5 text-[11px] font-weight-bold grey--text text--darken-2 border-r whitespace-nowrap uppercase"
            >
              {{ entry.voucherType || 'Journal' }} Voucher
            </td>
            <td
              class="px-2 py-1.5 text-[11px] font-weight-black grey--text text--darken-4 border-r whitespace-nowrap uppercase"
            >
              {{ entry.voucherNo || '-' }}
            </td>
            <td
              class="px-2 py-1.5 text-[11px] font-weight-bold grey--text border-r whitespace-nowrap"
            >
              {{ entry.instrumentNo || '0' }}
            </td>
            <td
              class="px-2 py-1.5 text-right text-[11px] font-weight-black grey--text text--darken-4 border-r tabular-nums"
            >
              {{ entry.debit > 0 ? formatCurrency(entry.debit) : '0' }}
            </td>
            <td
              class="px-2 py-1.5 text-right text-[11px] font-weight-black grey--text text--darken-4 border-r tabular-nums"
            >
              {{ entry.credit > 0 ? formatCurrency(entry.credit) : '0' }}
            </td>
            <td
              class="px-2 py-1.5 text-right text-[11px] font-weight-black primary--text border-r tabular-nums bg-slate-50/30"
            >
              {{ formatCurrency(entry.balance) }}
            </td>
            <td
              class="px-2 py-1.5 text-center text-[10px] font-weight-black border-r"
              :class="entry.crDr === 'Dr' ? 'blue--text' : 'red--text'"
            >
              {{ entry.crDr }}
            </td>
            <td
              class="px-2 py-1.5 text-[10px] font-weight-bold grey--text text--darken-1 border-r max-w-[200px] truncate-2-lines leading-tight"
            >
              {{ entry.comments }}
            </td>
            <!-- <td
              class="px-2 py-1.5 text-[10px] font-weight-black grey--text uppercase tracking-tight"
            >
              <v-chip
                x-small
                outlined
                :color="entry.postingType === 'Auto' ? 'success' : 'primary'"
                class="font-weight-black"
              >
                {{ entry.postingType }}
              </v-chip>
            </td> -->
          </tr>
        </tbody>
        <!-- Table Footer for Totals -->
        <tfoot
          v-if="filteredEntries.length"
          class="bg-slate-100 sticky bottom-0 z-30 border-t-2 border-slate-300 shadow-[0_-4px_8px_rgba(0,0,0,0.05)]"
        >
          <tr class="font-weight-black uppercase">
            <td
              colspan="6"
              class="px-4 py-4 text-right text-[11px] grey--text text--darken-3 tracking-widest font-weight-black border-r"
            >
              Ledger Summary (Total)
            </td>
            <td
              class="px-2 py-4 text-right text-[11px] grey--text text--darken-4 tabular-nums border-r bg-white/50"
            >
              {{ formatCurrency(totalDebit) }}
            </td>
            <td
              class="px-2 py-4 text-right text-[11px] grey--text text--darken-4 tabular-nums border-r bg-white/50"
            >
              {{ formatCurrency(totalCredit) }}
            </td>
            <td
              class="px-2 py-4 text-right text-[12px] primary--text tabular-nums border-r bg-white"
            >
              {{ formatCurrency(Math.abs(finalBalance)) }}
            </td>
            <!-- <td
              class="px-2 py-4 text-center text-[11px] border-r"
              :class="finalBalance >= 0 ? 'blue--text text--darken-3' : 'red--text text--darken-3'"
            >
              {{ finalBalance >= 0 ? 'Dr' : 'Cr' }}
            </td> -->
            <td
              colspan="2"
              class="px-4 py-4 text-[10px] grey--text text--darken-1 italic normal-case font-weight-medium"
            >
              Closing Balance for Filtered Records
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import CaseLedgerPDF from './CaseLedgerPDF.vue'
import CaseLedgerPDFMake from './CaseLedgerPDFMake.vue'

export default {
  name: 'CaseLedger',
  components: {
    CaseLedgerPDF,
    CaseLedgerPDFMake
  },
  props: {
    selectedCase: {
      type: Object,
      required: true
    },
    branchName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      search: '',
      apiData: [],
      liveAccounts: [],
      currentRequestId: 0
    }
  },
  computed: {
    totalDebit() {
      return this.filteredEntries.reduce((sum, e) => sum + (e.isDeleted ? 0 : e.debit || 0), 0)
    },
    totalCredit() {
      return this.filteredEntries.reduce((sum, e) => sum + (e.isDeleted ? 0 : e.credit || 0), 0)
    },
    finalBalance() {
      return this.totalDebit - this.totalCredit
    },
    computedBranchName() {
      if (this.branchName && this.branchName !== '-') {
        return this.branchName
      }
      const branchVal = this.selectedCase?.branch
      if (branchVal && typeof branchVal === 'object') {
        return branchVal.branchName || branchVal.name || ''
      }
      if (branchVal && typeof branchVal === 'string' && !/^[0-9a-fA-F]{24}$/.test(branchVal)) {
        return branchVal
      }
      return this.selectedCase?.branchName || ''
    },
    filteredEntries() {
      if (!this.search) return this.flattenedEntries
      const s = this.search.toLowerCase()
      return this.flattenedEntries.filter((e) => {
        return (
          (e.particulars && e.particulars.toLowerCase().includes(s)) ||
          (e.voucherNo && e.voucherNo.toLowerCase().includes(s))
        )
      })
    },
    flattenedEntries() {
      let entries = []

      this.apiData.forEach((journalLine) => {
        const name = this.getAccountName(journalLine.ledgerGroupId).toLowerCase()
        const isSelfAccount =
          name.includes('loan principal') ||
          name.includes('loan current portion') ||
          name.includes('installment') ||
          name.includes('principal receivable')

        // In the split model, we already have the line item (journalLine)
        // We just need to determine if we show this specific line
        // Usually, CaseLedger shows the "Other side" of the transaction for the loan account.
        // If the query was by loanId, we get all journal entries linked to that loan.

        const ledgerDebit = Number(journalLine.debit) || 0
        const ledgerCredit = Number(journalLine.credit) || 0

        entries.push({
          date: journalLine.date,
          createdAt: journalLine.createdAt,
          particulars:
            journalLine.particulars ||
            journalLine.accountsManagement?.name ||
            this.getAccountName(journalLine.ledgerGroupId),
          voucherType: journalLine.voucherType || 'Journal',
          voucherNo: journalLine.voucherNo || journalLine.accountsManagement?.journalNo || '0',
          instrumentNo: journalLine.instrumentNo || '0',
          debit: ledgerDebit,
          credit: ledgerCredit,
          isDeleted: journalLine.isDeleted || journalLine.accountsManagement?.isDeleted,
          comments: journalLine.description || journalLine.accountsManagement?.notes || '-',
          postingType: journalLine.accountsManagement?.journalType === 'Manual' ? 'Manual' : 'Auto'
        })
      })

      // Sort entries by date (chronological)
      entries.sort((a, b) => {
        const dateDiff = new Date(a.date) - new Date(b.date)
        if (dateDiff !== 0) return dateDiff
        return new Date(a.createdAt) - new Date(b.createdAt)
      })

      // Calculate running balance on sorted entries
      let cumulativeBalance = 0
      entries.forEach((entry) => {
        if (!entry.isDeleted) {
          cumulativeBalance += entry.debit - entry.credit
        }
        entry.balance = Math.abs(cumulativeBalance)
        entry.crDr = cumulativeBalance >= 0 ? 'Dr' : 'Cr'
      })
      return entries
    }
  },
  mounted() {
    this.initLedger()
  },
  methods: {
    async initLedger() {
      await this.fetchAccounts()
      this.fetchLedgerData(1)
    },
    async fetchAccounts() {
      try {
        const res = await this.$axios.get('/orgSetup/ledger-groups')
        this.liveAccounts = res.data.ledgerGroups || []
      } catch (e) {
        console.error('Ledger Groups fetch failed')
      }
    },
    async fetchLedgerData(page = 1, requestId = null) {
      const loanId = this.selectedCase?.loanDetails?._id || this.selectedCase?._id
      if (!loanId) return

      // Synchronization logic
      if (page === 1) {
        this.currentRequestId++
        this.apiData = []
        this.loading = true
      }

      const activeRequestId = page === 1 ? this.currentRequestId : requestId
      const limit = 500

      try {
        const params = {
          // loanId: loanId,
          accountsManagementId: this.selectedCase?.loanDetails?.connectedLedger,
          limit: limit,
          page: page,
          voucherTypeId: '2,3,4,5'
          // isSpecific: false
        }
        const response = await this.$axios.get('/orgSetup/journals/case-ledger', { params })

        if (activeRequestId !== this.currentRequestId) return

        const data = response.data.journals || []
        const totalCount = response.data.pagination?.totalCount || 0

        // Filter out the connected ledger entries from the display
        // const filteredItems = data.filter(
        //   (i) => i.accountsManagementId !== this.selectedCase?.loanDetails?.connectedLedger
        // )
        this.apiData = [...this.apiData, ...data]

        // Standard pagination check:
        // 1. If we got less data than the limit, we've reached the end
        // 2. If we've already fetched totalCount items from the server, we've reached the end
        const totalFetchedFromServer = (page - 1) * limit + data.length
        if (data.length === limit && totalFetchedFromServer < totalCount) {
          await this.fetchLedgerData(page + 1, activeRequestId)
        }
      } catch (error) {
        if (activeRequestId === this.currentRequestId) {
          console.error('Fetch error:', error)
          this.$toast.error('Failed to load ledger records')
        }
      } finally {
        if (activeRequestId === this.currentRequestId && page === 1) {
          this.loading = false
        }
      }
    },
    getAccountName(accRef) {
      if (accRef && typeof accRef === 'object' && accRef.name) return accRef.name
      const acc = this.liveAccounts.find((a) => a._id === (accRef?._id || accRef))
      return acc ? acc.name : 'Unknown Account'
    },
    formatDate(date) {
      return date ? this.$dayjs(date).format('DD-MM-YYYY') : '-'
    },
    formatDateTime(date) {
      return date ? this.$dayjs(date).format('DD-MM-YYYY HH:mm:ss') : '-'
    },
    formatCurrency(val) {
      return Number(val || 0).toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    downloadLedgerPDF() {
      if (this.$refs.ledgerPDF) {
        this.$refs.ledgerPDF.generatePDF()
      }
    },
    downloadLedgerPDFMake() {
      if (this.$refs.ledgerPDFMake) {
        this.$refs.ledgerPDFMake.generatePDF()
      }
    }
  }
}
</script>

<style scoped>
.ledger-table {
  width: 100%;
  border-spacing: 0;
  border-collapse: separate;
}
.ledger-table th,
.ledger-table td {
  border-bottom: 1px solid #e2e8f0 !important;
}
.ledger-table th {
  background-color: #f1f5f9 !important;
  color: #334155 !important;
  height: 40px;
}
.ledger-table td {
  height: 38px;
}
.border-r {
  border-right: 1px solid #e2e8f0 !important;
}
.truncate-2-lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.tabular-nums {
  font-variant-numeric: tabular-nums;
}
.sticky {
  position: sticky !important;
}
.soft-deleted-row {
  background-color: #fff1f2 !important;
  text-decoration: line-through;
  opacity: 0.7;
}
.soft-deleted-row td {
  color: #94a3b8 !important;
}
</style>
